/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { any } from 'prop-types';

// https://material-ui.com/components/tabs/

/* eslint-disable react/jsx-props-no-spreading */

const TabPanel = ({
    children, value, index, ...other
}) => (
    <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
    >
        {value === index && (
            <Box p={2}>
                <Typography>{children}</Typography>
            </Box>
        )}
    </div>
);

TabPanel.propTypes = {
    children: any.isRequired,
    value: any.isRequired,
    index: any.isRequired,
};

export default TabPanel;
